module.exports = __webpack_public_path__ + "img/image02_sp.82a06693.jpg";